import { render, staticRenderFns } from "./PanelWithBasicJobInfo.vue?vue&type=template&id=62d86780&lang=pug&"
import script from "./PanelWithBasicJobInfo.vue?vue&type=script&lang=ts&"
export * from "./PanelWithBasicJobInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithBasicJobInfo.vue?vue&type=style&index=0&id=62d86780&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports